import dayjs$1 from 'dayjs';
import arraySupport from 'dayjs/plugin/arraySupport';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import objectSupport from 'dayjs/plugin/objectSupport';
import 'dayjs/locale/en';
import 'dayjs/locale/fr';

/**
 * This module serves as our common export for dayjs with all our required
 * plugins installed already.
 */
var dayjsExtended = dayjs$1;
dayjsExtended.extend(arraySupport);
dayjsExtended.extend(objectSupport);
dayjsExtended.extend(customParseFormat);
dayjsExtended.extend(localizedFormat);
var dayjs = dayjsExtended;

export { dayjs as default };
